export const IRST_STATE_REJECTED_PATHS = {
    FEDERAL_RESUBMIT: "federalresubmit",
    STATE_RESUBMIT: "stateresubmit",
    RECONCILIATION_RESUBMIT: "reconciliationsubmit",
    STATE_PAYROLL_RESUBMIT: "statepayrollresubmit",
}

export const IRS_FEDERAL_RESUBMIT_LOADING_STATES = {
    FETCHING_REFERENCES_LOADING: "FETCHING_REFERENCES_LOADING",
    FETCHING_REFERENCES_READY: "FETCHING_REFERENCES_READY",
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    DOWNLOAD_ALL_PDF_LOADING: "DOWNLOAD_ALL_PDF_LOADING",
    DOWNLOAD_ALL_PDF_READY: "DOWNLOAD_ALL_PDF_READY",
    DOWNLOAD_MULTIPLE_PDF_LOADING: "DOWNLOAD_MULTIPLE_PDF_LOADING",
    DOWNLOAD_MULTIPLE_PDF_READY: "DOWNLOAD_MULTIPLE_PDF_READY",
    EXPORT_EXCEL_LOADING: "EXPORT_EXCEL_LOADING",
    EXPORT_EXCEL_READY: "EXPORT_EXCEL_READY",
    EXPORT_EXCEL_FOR_ALL_LOADING: "EXPORT_EXCEL_FOR_ALL_LOADING",
    EXPORT_EXCEL_FOR_ALL_READY: "EXPORT_EXCEL_FOR_ALL_READY",
}

export const IRS_FEDERAL_RESUBMIT_MESSAGE_MAP = {
    [IRS_FEDERAL_RESUBMIT_LOADING_STATES.FETCHING_REFERENCES_LOADING]: "",
    [IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_LOADING]: "",
    [IRS_FEDERAL_RESUBMIT_LOADING_STATES.DOWNLOAD_ALL_PDF_LOADING]: "",
    [IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_LOADING]: "",
    [IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_FOR_ALL_LOADING]: "",
}

export const IRS_STATE_RESUBMIT_LOADING_STATES = {
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READy",
    FETCHING_GRID_RECORDS_LOADING: "FETCHING_GRID_RECORDS_LOADING",
    FETCHING_GRID_RECORDS_READY: "FETCHING_GRID_RECORDS_READY",
    FETCHING_STATES_LIST_LOADING: "FETCHING_STATES_LIST_LOADING",
    FETCHING_STATES_LIST_READY: "FETCHING_STATES_LIST_READY",
    FETCHING_VIEW_PDF_LIST_LOADING: "FETCHING_VIEW_PDF_LIST_LOADING",
    FETCHING_VIEW_PDF_LIST_READY: "FETCHING_VIEW_PDF_LIST_READY",
    FETCHING_YEARS_LIST_LOADING: "FETCHING_YEARS_LIST_LOADING",
    FETCHING_YEARS_LIST_READY: "FETCHING_YEARS_LIST_READY",
    UPDATE_WITHHELD_ID_LOADING: "UPDATE_WITHHELD_ID_LOADING",
    UPDATE_WITHHELD_ID_READY: "UPDATE_WITHHELD_ID_READY",
}

export const IRS_STATE_RESUBMIT_MESSAGE_MAP = {
    [IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "",
    [IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]: "",
    [IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_YEARS_LIST_LOADING]: "",
    [IRS_STATE_RESUBMIT_LOADING_STATES.UPDATE_WITHHELD_ID_LOADING]: "",
}

export const RECONCILIATION_RESUBMIT_LOADING_STATES = {
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READY",
    VIEW_PDF_LOADING: "VIEW_PDF_LOADING",
    VIEW_PDF_READY: "VIEW_PDF_READY",
}

export const RECONCILIATION_RESUBMIT_MESSAGE_MAP = {
    [RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "",
    [RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [RECONCILIATION_RESUBMIT_LOADING_STATES.VIEW_PDF_LOADING]: "",
}